import { helper } from '@ember/component/helper';

export function boolToInt(params) {
  var value = params[0];

  if (value === true) {
    return 1;
  }

  if (value === false) {
    return 0;
  }

  return value;
}

export default helper(boolToInt);
